<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { cn, Toast } from '@/shared/ui'
import { useUiStore } from '@/stores/ui'

import AppBreadcrumb from './AppBreadcrumb.vue'
import AppSidebar from './AppSidebar.vue'
import AppTopbar from './AppTopbar.vue'

/**
 * Shell aplikácie.
 *
 * Sidebar je fixný, takže obsah dostane odsadenie zľava rovné jeho šírke.
 * Pod 1024 px sa sidebar skryje úplne — na tablete aj mobile je prioritou
 * šírka formulára a cenového panela, nie navigácia (handoff.md, responzívnosť).
 */
const route = useRoute()
const ui = useUiStore()

const titleSk = computed(() => route.meta.titleSk)
const trailSk = computed(() => route.meta.breadcrumbSk ?? [])
</script>

<template>
	<div class="min-h-dvh bg-bg">
		<AppSidebar class="hidden lg:flex" />

		<div
			:class="
				cn(
					'flex min-h-dvh flex-col',
					ui.sidebarCollapsed ? 'lg:pl-(--sidebar-w-collapsed)' : 'lg:pl-(--sidebar-w)',
				)
			"
		>
			<AppTopbar class="sticky top-0 z-(--z-sticky)" />

			<main class="flex flex-1 flex-col gap-3 p-3 lg:p-4">
				<header class="flex flex-col gap-1">
					<AppBreadcrumb :trail-sk="trailSk" :current-sk="titleSk" />
					<h1 class="text-xl leading-tight font-semibold text-fg">{{ titleSk }}</h1>
				</header>

				<slot />
			</main>
		</div>

		<Toast />
	</div>
</template>
